import { LocationInfo } from 'api/Main';

export const getLocationFromStr = (str: string): LocationInfo => {
  const [env, swiftId, id, entranceID, ...name] = str.split('-');
  return {
    env, swiftId, id, entranceID, name: name && name.join(" ")
  }
}